export const GlobalIconDefs = () => (
  <svg width="0" height="0" style={{ position: 'absolute' }}>
    <defs>
      <linearGradient
        id="app-icon-gradient-1"
        x1="0"
        y1="0"
        x2="24"
        y2="24"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0%" stopColor="#9A56EE" />
        <stop offset="100%" stopColor="#006AFF" />
      </linearGradient>
      <linearGradient
        id="app-icon-gradient-2"
        x1="0"
        y1="0"
        x2="24"
        y2="24"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0%" stopColor="#027bfe" />
        <stop offset="100%" stopColor="#2fcc71" />
      </linearGradient>
      <linearGradient
        id="app-icon-gradient-3"
        x1="0"
        y1="0"
        x2="24"
        y2="24"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0%" stopColor="#006BFF" />
        <stop offset="100%" stopColor="#28C76F" />
      </linearGradient>
    </defs>
  </svg>
);
